import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin-block: 20px;
`;
